module.exports = __webpack_public_path__ + "static/assets/1b03c7316fd577db0df2948594c0de38.gif";